module.exports = __webpack_public_path__ + "media/organizations/dhl-72a297b9.svg";